import React, { memo, useContext, useMemo } from 'react'
import { CircleTickMinor } from '@shopify/polaris-icons'
import { ContractorState, ContractorStatus } from 'src/constants/contractor/enums'
import { ContractorStatusChip } from './ContractorStatusChip'
import { ContractorsTableContext } from '../contractors-table/ContractorsTable.context'
import { TableSelect } from 'src/components/shared/table/TableSelect'

interface Props {
  selectedContractorState: ContractorState
}

const ContractorStatusSelectComponent = ({ selectedContractorState }: Props) => {
  const { statusFilter, setStatusFilter } = useContext(ContractorsTableContext)

  const statuses = useMemo(() => {
    if (selectedContractorState === ContractorState.Active) {
      return [
        {
          value: ContractorStatus.Active,
          component: <ContractorStatusChip status={ContractorStatus.Active} />,
        },
        {
          value: ContractorStatus.ExpiresSoon,
          component: <ContractorStatusChip status={ContractorStatus.ExpiresSoon} />,
        },
      ]
    }

    if (selectedContractorState === ContractorState.Recollection) {
      return [
        {
          value: ContractorStatus.Active,
          component: <ContractorStatusChip status={ContractorStatus.Active} />,
        },
        {
          value: ContractorStatus.Deactivated,
          component: <ContractorStatusChip status={ContractorStatus.Deactivated} />,
        },
        {
          value: ContractorStatus.ExpiresSoon,
          component: <ContractorStatusChip status={ContractorStatus.ExpiresSoon} />,
        },
      ]
    }

    return []
  }, [selectedContractorState])

  if (selectedContractorState === ContractorState.Deactivated) {
    return null
  }

  return (
    <TableSelect<ContractorStatus>
      title="Status"
      selectedValues={statusFilter}
      icon={<CircleTickMinor width={20} />}
      options={statuses}
      onSelect={setStatusFilter}
    />
  )
}

export const ContractorStatusSelect = memo(ContractorStatusSelectComponent)
